<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	let props: HTMLAttributes<SVGElement> = $props();
</script>

<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
	<rect width="24" height="24" rx="12" fill="#20493E" />
	<g clip-path="url(#clip0_17251_3068)">
		<mask
			id="mask0_17251_3068"
			style="mask-type:alpha"
			maskUnits="userSpaceOnUse"
			x="2"
			y="2"
			width="20"
			height="20"
		>
			<rect x="2" y="2" width="20" height="20" fill="#D9D9D9" />
		</mask>
		<g mask="url(#mask0_17251_3068)">
			<path
				d="M10.3334 13.604L15.4167 8.52067C15.5695 8.36789 15.7466 8.2915 15.948 8.2915C16.1494 8.2915 16.3265 8.36789 16.4792 8.52067C16.632 8.67345 16.7084 8.85053 16.7084 9.05192C16.7084 9.25331 16.632 9.43039 16.4792 9.58317L10.8542 15.2082C10.7015 15.3609 10.5244 15.4373 10.323 15.4373C10.1216 15.4373 9.94453 15.3609 9.79175 15.2082L7.52091 12.9373C7.36814 12.7846 7.29175 12.6075 7.29175 12.4061C7.29175 12.2047 7.36814 12.0276 7.52091 11.8748C7.67369 11.7221 7.85078 11.6457 8.05216 11.6457C8.25355 11.6457 8.43064 11.7221 8.58341 11.8748L10.3334 13.604Z"
				fill="#DFEDDD"
			/>
		</g>
	</g>
	<defs>
		<clipPath id="clip0_17251_3068">
			<rect width="20" height="20" fill="white" transform="translate(2 2)" />
		</clipPath>
	</defs>
</svg>
